import { getLiquidTokenSymbol, truncateBalance } from '@ewf/lib/utils';
import { displayBalance } from '@ewf/utils/balance-helpers';
import { SunkenBox } from '@ewf/components/SunkenBox';
import ewLogo from '@ewf/assets/logos/ew.svg';
import bridgeIcon from '@ewf/assets/icons/bridge-gradient.svg';
import stakeIcon from '@ewf/assets/icons/stake-gradient.svg';
import { useBalanceStore } from '@ewf/stores/balance';

export const AccountMainInfo = (): React.ReactNode => {
  const liquidBalance = useBalanceStore((state) => state.liquidBalance);

  return (
    <div className="mb-6 rounded-lg p-4 bg-popup-gradient">
      <SunkenBox className="mb-3 text-center">
        <div className="mb-0 flex items-center justify-center gap-2">
          <img
            src={ewLogo}
            className="rounded-full fill-white"
            width={24}
            height={24}
            alt="Energy Web Token"
          />
          <h2 className="">
            {displayBalance(truncateBalance(liquidBalance || '0'))} {getLiquidTokenSymbol()}
          </h2>
        </div>
      </SunkenBox>
      {/* TODO: Update icons */}
      <div className="grid grid-cols-2 gap-1 rounded-lg">
        <a
          href="https://bridging.energywebx.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full flex-col items-center justify-between gap-2 rounded-l-lg rounded-r-md bg-gray-90 py-2 text-sm text-teal shadow hover:bg-gray-80 hover:outline hover:outline-1 hover:outline-brand active:bg-gray-95"
        >
          <img src={bridgeIcon} width={24} height={24} alt="Bridge" />
          <p>Bridge</p>
        </a>
        <a
          href="https://staking.energywebx.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-full flex-col items-center justify-between gap-2 rounded-l-md rounded-r-lg bg-gray-90 py-2 text-sm text-teal shadow hover:bg-gray-80 hover:outline hover:outline-1 hover:outline-brand active:bg-gray-95"
        >
          <img src={stakeIcon} width={24} height={24} alt="Stake" />
          <p>Stake</p>
        </a>
      </div>
    </div>
  );
};
